var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"its-about-e-class"},[_c('div',{staticClass:"its-image its-image-bg-1"}),_c('div',{staticClass:"its-image its-image-bg-2"}),_c('class-title',{staticClass:"its-about-e-class-title",attrs:{"title":_vm.item.title}}),_c('div',{staticClass:"its-about-e-class-desc",domProps:{"innerHTML":_vm._s(_vm.item.desc)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }